class ContactAccordionFilter extends HTMLElement {
  constructor() {
    super();
 
    this.trigger = document.getElementById("ContactForm-topic");
    this.accordionItems = document.querySelectorAll(".contact__faq");
    this.options = this.trigger.querySelectorAll("option");

    this.listeners();    
  }
  
  listeners() {
    this.trigger.addEventListener("change", event => this.filterAccordion(event.target.value));
  }

  filterAccordion(chosenTopic) {
    this.accordionItems.forEach(faq => {
      const topic = faq.dataset.topic;

      chosenTopic === topic
        ? faq.classList.add("contact__faq--active")
        : faq.classList.remove("contact__faq--active");
    });
  }
}

customElements.define("contact-accordion-filter", ContactAccordionFilter);
